import { faHeartPulse, faUserGroup } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Form, Row } from 'antd'
import React from 'react'
import Templates from '../../../../Medical History/utils/templates'
import PrevNextFloatingButtons from '../../../Reusable Components/Buttons/PrevNextFloatingButtons'
import useFamilyHistory from '../../hooks/useFamilyHistory'
import '../style/MobFamilyHistory.css'
import MobSectionHeader from './MobSectionHeader'

const MobFamilyHistory = ({ clientForm, setFacet, setSaving }) => {
  const { handleOptionClick, handleSubmit, selectedConditions } = useFamilyHistory({ clientForm, setFacet, setSaving })
  return (
    <>
      <MobSectionHeader
        icon={faUserGroup}
        title='Family History'
        subtitle='Do any of your immediate family members have these conditions?'
      />

      {/* Conditions List */}
      <Row gutter={[16, 16]}>
        {Templates.dataModel.familyHistoryList.options.map((condition, index) => (
          <Col span={24}>
            <div
              key={index}
              className='condition-card'
              role='checkbox'
              onClick={() => handleOptionClick(condition)}
              aria-checked={selectedConditions.includes(condition.value)}
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleOptionClick(condition)
                }
              }}
            >
              <div className='condition-icon'>
                <FontAwesomeIcon icon={faHeartPulse} />
              </div>
              <span className='condition-name'>{condition.label}</span>
              <Form.Item name={['familyHistory', 'list']} style={{ display: 'none' }}>
                <input type='checkbox' />
              </Form.Item>
            </div>
          </Col>
        ))}
      </Row>

      {/* Bottom Action Buttons */}
      <PrevNextFloatingButtons
        onPrev={() => {
          clientForm.resetFields()
          setFacet(null)
        }}
        onNext={handleSubmit}
        prevText='Back'
        nextText='Save'
      />
    </>
  )
}

export default MobFamilyHistory
